module.exports = __webpack_public_path__ + "static/media/alarm.15d44e3f.svg";